import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";

const LINK_META = [
  { key: "doi", label: "DOI" },
  { key: "pdf", label: "PDF" },
  { key: "slides", label: "Slides" },
  { key: "service", label: "Service" },
  { key: "github", label: "GitHub" },
  { key: "article", label: "Article" },
];

function LinkIcon({ kind }) {
  switch (kind) {
    case "doi":
      return (
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          aria-hidden="true"
        >
          <defs>
            <mask id="doi-text-mask">
              <rect width="24" height="24" fill="white" />
              <text
                x="12"
                y="16"
                textAnchor="middle"
                fontFamily="Inter, system-ui, sans-serif"
                fontSize="10.5"
                fontWeight="800"
                letterSpacing="0.2"
                fill="black"
              >
                DOI
              </text>
            </mask>
          </defs>
          <rect
            x="1"
            y="4"
            width="22"
            height="16"
            rx="3"
            fill="currentColor"
            mask="url(#doi-text-mask)"
          />
        </svg>
      );
    case "pdf":
      return (
        <svg
          viewBox="0 0 256 256"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="216 152 184 152 184 208" />
          <line x1="208" y1="184" x2="184" y2="184" />
          <path d="M48,192H64a20,20,0,0,0,0-40H48v56" />
          <path d="M112,152v56h16a28,28,0,0,0,0-56Z" />
          <path d="M48,112V40a8,8,0,0,1,8-8h96l56,56v24" />
          <polyline points="152 32 152 88 208 88" />
        </svg>
      );
    case "slides":
      return (
        <svg
          viewBox="14 0 256 256"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="16"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <line x1="136" y1="184" x2="136" y2="224" />
          <line x1="136" y1="32" x2="136" y2="72" />
          <line x1="152" y1="128" x2="232" y2="128" />
          <rect x="32" y="72" width="120" height="112" rx="8" />
          <path d="M80,136H96a16,16,0,0,0,0-32H80v48" />
          <path d="M58,72a96,96,0,1,1,0,112" />
        </svg>
      );
    case "service":
      return (
        <svg
          viewBox="1 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="9" />
          <line x1="3" y1="12" x2="21" y2="12" />
          <path d="M12 3a14.5 14.5 0 0 1 0 18 14.5 14.5 0 0 1 0-18z" />
        </svg>
      );
    case "github":
      return (
        <svg
          viewBox="0 0 24 24"
          width="21"
          height="21"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.39 7.86 10.91.58.1.79-.25.79-.56 0-.27-.01-1.16-.02-2.1-3.2.7-3.88-1.36-3.88-1.36-.52-1.34-1.28-1.69-1.28-1.69-1.05-.72.08-.7.08-.7 1.16.08 1.77 1.19 1.77 1.19 1.03 1.77 2.71 1.26 3.37.97.11-.75.4-1.26.73-1.55-2.55-.29-5.24-1.28-5.24-5.69 0-1.26.45-2.28 1.18-3.09-.12-.29-.51-1.46.11-3.04 0 0 .97-.31 3.18 1.18a11 11 0 0 1 5.78 0c2.21-1.49 3.18-1.18 3.18-1.18.62 1.58.23 2.75.11 3.04.74.81 1.18 1.83 1.18 3.09 0 4.42-2.69 5.4-5.25 5.68.41.36.78 1.06.78 2.14 0 1.55-.01 2.79-.01 3.17 0 .31.21.67.8.56C20.22 21.39 23.5 17.08 23.5 12 23.5 5.65 18.35.5 12 .5z" />
        </svg>
      );
    case "article":
      return (
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M14.5 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
          <line x1="7" y1="13" x2="12" y2="13" />
          <line x1="7" y1="17" x2="11" y2="17" />
          <path d="M18.4 2.6a1.7 1.7 0 0 1 2.4 2.4L13 12.8l-3.1.7.7-3.1 7.8-7.8z" />
        </svg>
      );
    default:
      return null;
  }
}

function PubLinks({ links }) {
  if (!links) return null;
  const items = LINK_META.filter((m) => links[m.key] && links[m.key].length > 0);
  if (items.length === 0) return null;
  return (
    <div className="pub__links">
      {items.map((m) => (
        <a
          key={m.key}
          href={links[m.key]}
          className="pub__link-icon"
          target="_blank"
          rel="noreferrer"
          aria-label={m.label}
          title={m.label}
        >
          <LinkIcon kind={m.key} />
        </a>
      ))}
    </div>
  );
}

function AuthorList({ authors, meIndices }) {
  const me = new Set(meIndices);
  return (
    <span className="pub__authors">
      {authors.map((a, i) => (
        <span key={i}>
          {me.has(i) ? <span className="pub__me">{a}</span> : a}
          {i < authors.length - 1 ? ", " : ""}
        </span>
      ))}
    </span>
  );
}

function PubItem({ item, num }) {
  return (
    <li className="pub">
      <div className="pub__num">{num}.</div>
      <div className="pub__body">
        <AuthorList authors={item.authors} meIndices={item.meIndices} />
        <div className="pub__title">{item.title}</div>
        <div className="pub__venue">
          {item.venue}
          {item.note ? ` (${item.note})` : ""}
          {`, ${item.year}.`}
        </div>
        <PubLinks links={item.links} />
      </div>
    </li>
  );
}

function Group({ title, items }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="pub-group">
      <h3 className="pub-group__title">{title}</h3>
      <ul className="pub-group__list">
        {items.map((p, i) => (
          <PubItem key={p.id} item={p} num={i + 1} />
        ))}
      </ul>
    </div>
  );
}

export default function Publications() {
  const { t } = useLang();
  const { publications } = useData();

  return (
    <section id="publications" className="section">
      <div className="section__header">
        <h2 className="section__title">{t.nav.publications}</h2>
      </div>

      <Group
        title={t.publications.international}
        items={publications.international}
      />
      <Group title={t.publications.posters} items={publications.posters} />
      <Group
        title={t.publications.domesticPeerReviewed}
        items={publications.domesticPeerReviewed}
      />
      <Group
        title={t.publications.domesticNonPeerReviewed}
        items={publications.domesticNonPeerReviewed}
      />
    </section>
  );
}
